import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from './auth.state';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    // Login
    'Login': props<{ email: string; password: string }>(),
    'Login Success': props<{ message: string; token: string, refreshToken: string }>(),
    'Login Failure': props<{ error: string }>(),

    // Login Admin
    'Login Admin': props<{ email: string; password: string }>(),
    'Login Admin Success': props<{ message: string; token: string, refreshToken: string }>(),
    'Login Admin Failure': props<{ error: string }>(),

    // Register
    'Register': props<{ requestBody: { email: string; password: string; fullName: string; nationalIdNumber: string; phoneNumber: string; gender: string } }>(),
    'Register Success': props<{ message: string }>(),
    'Register Failure': props<{ error: string }>(),

    // Logout
    'Logout': emptyProps(),
    'Logout Success': emptyProps(),

    // Get Current User
    'Get Current User': emptyProps(),
    'Get Current User Success': props<{ user: User }>(),
    'Get Current User Failure': props<{ error: string }>(),

    // Clear Error
    'Clear Error': emptyProps(),
  },
}); 